import { createContext, type ReactNode, useContext, useMemo } from 'react'
import { getOrgSlug } from '@/lib/subdomain'

interface OrgContextValue {
  /** Org slug extracted from the subdomain, or null if on root domain */
  orgSlug: string | null
  /** Whether the app is running in subdomain mode */
  isSubdomain: boolean
}

const OrgContext = createContext<OrgContextValue | null>(null)

export function OrgProvider({ children }: { children: ReactNode }) {
  const value = useMemo<OrgContextValue>(() => {
    const slug = getOrgSlug()
    return { orgSlug: slug, isSubdomain: slug !== null }
  }, [])

  return <OrgContext.Provider value={value}>{children}</OrgContext.Provider>
}

export function useOrg(): OrgContextValue {
  const ctx = useContext(OrgContext)
  if (!ctx) throw new Error('useOrg must be used within an OrgProvider')
  return ctx
}
